// Tenant-side support tickets. Scoped server-side to the caller's tenant.
import { call } from './callable';

export type TicketStatus = 'open' | 'answered' | 'closed';
export type TicketPriority = 'low' | 'normal' | 'high';

export const TICKET_MODULES = [
  'general', 'billing', 'templates', 'broadcasts', 'inbox',
  'subscribers', 'automation', 'api', 'connection',
] as const;
export type TicketModule = (typeof TICKET_MODULES)[number];

export interface MyTicket {
  id: string;
  subject: string;
  module: TicketModule;
  priority: TicketPriority;
  status: TicketStatus;
  lastReplyBy: 'tenant' | 'staff';
  replyCount: number;
  createdAt: number;
  updatedAt: number;
}

export interface MyTicketReply {
  id: string;
  body: string;
  authorRole: 'tenant' | 'staff';
  createdAt: number;
}


const createC = call<{ subject: string; body: string; module: TicketModule; priority: TicketPriority }, { ticketId: string }>('supportCreateTicket');
const listC = call<Record<string, never>, { tickets: MyTicket[] }>('supportListTickets');
const getC = call<{ ticketId: string }, { ticket: MyTicket; replies: MyTicketReply[] }>('supportGetTicket');
const replyC = call<{ ticketId: string; body: string }, { ok: true }>('supportReplyTicket');

export const createTicket = async (p: { subject: string; body: string; module: TicketModule; priority: TicketPriority }) =>
  (await createC(p)).data;
export const listMyTickets = async () => (await listC({} as Record<string, never>)).data.tickets;
export const getMyTicket = async (ticketId: string) => (await getC({ ticketId })).data;
export const replyToTicket = async (ticketId: string, body: string) => (await replyC({ ticketId, body })).data;
